import './skills.scss';
import React, { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Skills: React.FC = () => {
  const skillsRef = useRef<HTMLElement>(null);
  const firstTextRef = useRef<HTMLDivElement>(null);
  const secondTextRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      const firstWords = firstTextRef.current?.querySelectorAll('.word');
      const secondWords = secondTextRef.current?.querySelectorAll('.word');

      if (!firstWords || !secondWords) return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: skillsRef.current,
          start: 'top top',
          end: '+=200%', // ⬅️ allunga lo scroll = più tempo fermo
          scrub: 1,
          pin: true,
        },
      });

      // 1️⃣ Visual Design
      tl.fromTo(
        firstWords,
        { color: 'rgba(248, 248, 248, 0.2)' },
        {
          color: 'rgba(248, 248, 248, 1)',
          stagger: 0.1,
          ease: 'power1.out',
        }
      )

      // 2️⃣ Web Developer
      .fromTo(
        secondWords,
        { color: 'rgba(248, 248, 248, 0.2)' },
        {
          color: 'rgba(248, 248, 248, 1)',
          stagger: 0.1,
          ease: 'power2.out',
        },
        '>'
      )

      // 3️⃣ PAUSA CINEMATICA (tutto acceso, niente succede)
      .to(
        {},
        { duration: .5 } // ⬅️ aumenta se vuoi più “godimento”
      );
    });

    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 500);

    return () => ctx.revert();
  }, []);

  const firstText =
    'Web Design, Mobile App Design, Animated Prototyping, Figma, Adobe Creative Suite, Accessibility';

  const secondText =
    'HTML, SCSS, JS, ES6, React, Angular, GSAP, Tailwind';

  const firstWords = firstText.split(' ').map((word, i, arr) => (
    <span key={i} className="word inline-block">
      {word}
      {i < arr.length - 1 && '\u00A0'}
    </span>
  ));

  const secondWords = secondText.split(',').map((word, i, arr) => (
    <span key={i} className="word inline-block">
      &nbsp;{word.trim()}
      {i < arr.length - 1 && ','}
    </span>
  ));

  return (
    <section
      ref={skillsRef}
      id="skills"
      className="skills grid grid-cols-12 gap-6 flex flex-col items-center bg-dark text-light h-screen px-6 py-6"
    >
      <div className="skills-container col-span-12 lg:col-span-10 lg:col-start-2 flex flex-col">
        <div className="flex flex-col gap-2 skills" ref={firstTextRef}>
          <span className="skills-title text-light-70">Visual Design</span>
          <p className="intro-text">{firstWords}</p>
        </div>

        <div className="flex flex-col gap-2 text-right skills" ref={secondTextRef}>
          <span className="skills-title text-light-70">Web Developer</span>
          <p className="intro-text">{secondWords}</p>
        </div>
      </div>
    </section>
  );
};

export default Skills;